/**
 * Created by rrr on 2017/3/9.
 */
if( !/Android|webOS|iPhone|iPod|iPad|BlackBerry/i.test(navigator.userAgent)) {
  $(function () {
    $(".numkeyboard").ioskeyboard({
      keyboardRadix: 80,//键盘大小基数，实际大小比为9.4，即设置为100时实际大小为940X330
      keyboardRadixMin: 40,//键盘大小的最小值，默认为60，实际大小为564X198
      keyboardRadixChange: true,//是否允许用户改变键盘大小,该功能仅能完美支持Chrome26；仅当keyboardRadixMin不小于60时才较好支持Safari内核浏览器
      clickeve: true,//是否绑定元素click事件
      colorchange: true,//是否开启按键记忆功能，如果开启，将随着按键次数的增加加深相应按键的背景颜色
      colorchangeStep: 1,//按键背景颜色改变步伐，采用RBG值，默认为RGB(255,255,255),没按一次三个数字都减去步伐值
      colorchangeMin: 154//按键背影颜色的最小值，默认为RGB(154,154,154)
    });
  });
}
(function($){
  $.fn.ioskeyboard = function(options){
    var defaults = {
      keyboardRadix:100,//键盘大小基数，实际大小比为9.4，即设置为100时实际大小为940X330
      keyboardRadixMin:60,//键盘大小的最小值，默认为60，实际大小为564X198
      keyboardRadixChange:true,//是否允许用户改变键盘大小,该功能仅能完美支持Chrome26；仅当keyboardRadixMin不小于60时，完美支持Safari内核浏览器
      clickeve:true,//是否绑定元素click事件
      colorchange:true,//是否开启按键记忆功能，如果开启，将随着按键次数的增加加深相应按键的背景颜色
      colorchangeStep:1,//按键背景颜色改变步伐，采用RBG值，默认为RGB(255,255,255),没按一次三个数字都减去步伐值
      colorchangeMin:154//按键背影颜色的最小值，默认为RGB(154,154,154)
    }
    var options = $.extend(defaults, options);
    var numkeyboardcount = 0;
    var activeinputele;
    var keyboardRadix = options.keyboardRadix;
    var keyboardRadixMin = options.keyboardRadixMin;
    var colorchange = options.colorchange;
    var colorchangeStep = options.colorchangeStep;
    var colorchangeMin = options.colorchangeMin;

    var keyfixed = false;
    if(keyboardRadix<keyboardRadixMin){
      keyboardRadix = keyboardRadixMin;
    }
    this.each(function(){
      numkeyboardcount++;
      //添加键盘
      if(numkeyboardcount<2){
        $("body").append("<ul id='keyboard_5xbogf8c'>"+
          "<li><span>!</span><span>1</span></li>"+
          "<li>2</li>"+
          "<li>3</li>"+
          "<li>4</li>"+
          "<li>5</li>"+
          "<li>6</li>"+
          "<li>7</li>"+
          "<li>8</li>"+
          "<li>9</li>"+
          "<li>0</li>"+
          "<li>←</li>"+
          "<li class='zimu'>q</li>"+
          "<li class='zimu'>w</li>"+
          "<li class='zimu'>e</li>"+
          "<li class='zimu'>r</li>"+
          "<li class='zimu'>t</li>"+
          "<li class='zimu'>y</li>"+
          "<li class='zimu'>u</li>"+
          "<li class='zimu'>i</li>"+
          "<li class='zimu'>o</li>"+
          "<li class='zimu'>p</li>"+
          "<li></li>"+
          "<li class='zimu'>a</li>"+
          "<li class='zimu'>s</li>"+
          "<li class='zimu'>d</li>"+
          "<li class='zimu'>f</li>"+
          "<li class='zimu'>g</li>"+
          "<li class='zimu'>h</li>"+
          "<li class='zimu'>j</li>"+
          "<li class='zimu'>k</li>"+
          "<li class='zimu'>l</li>"+
          "<li>Exit</li>"+
          "<li>CapsLock</li>"+
          "<li class='zimu'>z</li>"+
          "<li class='zimu'>x</li>"+
          "<li class='zimu'>c</li>"+
          "<li class='zimu'>v</li>"+
          "<li class='zimu'>b</li>"+
          "<li class='zimu'>n</li>"+
          "<li class='zimu'>m</li>"+
          "<li><span>-</span><span>_</span></li>"+
          "<li><span>/</span><span>.</span></li>"+
          "<li>Clear</li>"+
          "<div id='keyboard_5xbogf8c_left'></div>"+
          "<div id='keyboard_5xbogf8c_right'></div>"+
          "</ul>");
      }

      var inputele = $(this);
      console.log(inputele)
      var keyboard = $("#keyboard_5xbogf8c");
      var keys = keyboard.children("li");
      var hiddenbutton = keyboard.children("div");
      keyboard.css({"font-size":keyboardRadix+"px"});

      //keyboard.css({"position":"fixed","right":"0.05em","bottom":"0.05em"});
      exit();
      var shiftbool = false;
      if(numkeyboardcount<2){
        keyboard.dblclick(function(){
          if(keyfixed){
            keyfixed = false;
          }else{
            keyboard.css({"position":"fixed","right":"0.05em","bottom":"0.05em"});
            keyfixed = true;
          }
        });
        keys.click(function(event){
          var keyele = $(this);
          var keytext = keyele.text();
          var evebool = true;
          if(keytext==="CapsLock"){
            activeinputele[0].focus();
            if(shiftbool){
              keyele.css({background:"rgba(255,255,255,.9)"});
              shiftbool = false;

              //按下CapsLock转大小写
              var zimu = $(".zimu");
              for (var i = 0; i < zimu.length; i++) {
                zimu[i].innerHTML = zimu[i].innerHTML.toLowerCase();
              };
            }else{
              keyele.css({background:"rgba(188,188,188,.5)"});
              shiftbool = true;

              var zimu = $(".zimu");
              for (var i = 0; i < zimu.length; i++) {
                zimu[i].innerHTML = zimu[i].innerHTML.toUpperCase();
              };
            }

            evebool = false;
          }
          if(keytext==="Exit"||keytext.length<1){
            simulateKeyEvent(activeinputele[0],13);
            exit();
            evebool = false;
          }
          if(keytext==="←"){
            activeinputele[0].focus();
            backspace();
            evebool = false;
          }
          if(keytext==="Clear"){
            activeinputele[0].focus();
            keyclear();
            evebool = false;
          }
          if(evebool){
            if(shiftbool){
              if(keytext.length===2){
                keytext = keytext.substring(0,1);
              }else{
                keytext = keytext.toUpperCase();
              }
            }else{
              if(keytext.length===2){
                keytext = keytext.substring(1,2);
              }else{
                keytext = keytext.toLowerCase();
              }
            }
            clickkey(keytext);
            if(colorchange){
              var oldbabkground = $(this).css("background").split(',')[0].split('(')[1];
              var newbabkground = oldbabkground-colorchangeStep;
              if(newbabkground<colorchangeMin){
                newbabkground = colorchangeMin;
                alert("min")
              }
              $(this).css("background","rgba("+newbabkground+","+newbabkground+","+newbabkground+",.9)");
            }
          }
        })
        keyboard.children("li:eq("+21+")").mousedown(function(event){
          $(this).css({top:"4.6em", "box-shadow": "inset 0 0.04em 0 rgba(0,0,0,.5)"});
          keyboard.children("li:eq("+31+")").css({top:"0.1em","box-shadow": "inset 0 0em 0 rgba(0,0,0,.5)"});
        })
          .mouseup(function(event){
            $(this).css({top:"4.5em","box-shadow":" inset 0 0em 0 rgba(0,0,0,.5)"});
            keyboard.children("li:eq("+31+")").css({top:"0px","box-shadow":" inset 0 0em 0 rgba(0,0,0,.5)"});
          });
        keyboard.children("li:eq("+31+")").mousedown(function(event){
          $(this).css({top:"0.1em","box-shadow": "inset 0 0em 0 rgba(0,0,0,.5)"});
          keyboard.children("li:eq("+21+")").css({top:"4.6em", "box-shadow": "inset 0 0.04em 0 rgba(0,0,0,.5)"});
        })
          .mouseup(function(event){
            $(this).css({top:"0px","box-shadow":" inset 0 0em 0 rgba(0,0,0,.5)"});
            keyboard.children("li:eq("+21+")").css({top:"4.5em","box-shadow":" inset 0 0em 0 rgba(0,0,0,.5)"});
          });
      }

      inputele.focus(function(event){
        activeinputele = inputele;
        var p = GetScreenPosition(this);
        if(keyboard.css("display")=="none"){
          keyboard.css({"display":"block"});
        }
      });

      if(options.clickeve){
        inputele.click(function(){
          activeinputele = inputele;
          var p = GetScreenPosition(this);
          if(keyboard.css("display")=="none"){
            keyboard.css({"display":"block"});
          }
        });
      }

      function GetScreenPosition(object) {
        var position = {};
        position.x = object.offsetLeft;
        position.y = object.offsetTop;
        while (object.offsetParent) {
          position.x = position.x + object.offsetParent.offsetLeft;
          position.y = position.y + object.offsetParent.offsetTop;
          if (object == document.getElementsByTagName("body")[0]) {
            break;
          }
          else{
            object = object.offsetParent;
          }
        }
        return position;
      }

      function keyclear(){
        activeinputele.val("");
      }
      function backspace(){
        var inputtext = activeinputele.val();
        if(inputtext.length>0){
          inputtext = inputtext.substring(0,inputtext.length-1);
          activeinputele.val(inputtext);
        }
      }
      function clickkey(key){
        var inputtext = activeinputele.val();
        inputtext = inputtext+key;
        activeinputele.val(inputtext);
        activeinputele[0].focus();
      }

      function exit(){
        keyboard.css({"display":"none"});
      }

      var drag = new dragMing("#keyboard_5xbogf8c", "#keyboard_5xbogf8c");
      //移动键盘
      function dragMing(idORclass1, idORclass2) {
        var obj = this; //这里的this是指dragMing对象么
        this.idORclass1 = idORclass1; //给dragMing的idORclass1赋值
        this.idORclass2 = idORclass2; //给dragMing的idORclass2赋值
        this.deltaX = 0;
        this.deltaY = 0;

        function dragStart(dragEvent) {
          obj.deltaX = dragEvent.clientX - $(obj.idORclass2).offset().left;
          obj.deltaY = dragEvent.clientY - $(obj.idORclass2).offset().top;
          $(document).bind("mousemove", dragMove);
          $(document).bind("mouseup", dragStop);
          dragEvent.preventDefault();

        }
        function dragMove(dragEvent) {
          $(obj.idORclass2).css({
            "left": (dragEvent.clientX - obj.deltaX) + "px",
            "top": (dragEvent.clientY - obj.deltaY) + "px"
          })
          dragEvent.preventDefault();

        }
        function dragStop() {
          $(document).unbind("mousemove", dragMove);
          $(document).unbind("mouseup", dragStop);
        }

        $(document).ready(function () {
          $(obj.idORclass1).bind("mousedown", dragStart);
        })
      }

      //模拟键盘事件,仅支持firefox，ie8-
      function simulateKeyEvent(target,keyCode) {
        var customEvent = null;
        var a = typeof document.createEvent;

        if(typeof document.createEvent == "function"){//firefox
          try {
            customEvent = document.createEvent("KeyEvents");
            customEvent.initKeyEvent("keypress", true, true,window, false, false, false, false, keyCode, keyCode);
            target.dispatchEvent(customEvent);
          } catch (ex){
            //console.log("This example is only demonstrating event simulation in firefox and IE.");
          }
        } else if (document.createEventObject){ //IE
          customEvent = document.createEventObject();
          customEvent.bubbles = true;
          customEvent.cancelable = true;
          customEvent.view = window;
          customEvent.ctrlKey = false;
          customEvent.altKey = false;
          customEvent.shiftKey = false;
          customEvent.metaKey = false;
          customEvent.keyCode = keyCode;
          target.fireEvent("onkeypress", customEvent);
        }
        else {
          //console.log("This example is only demonstrating event simulation in firefox and IE.");
        }
      }
    });
  };
})(jQuery);



// WEBPACK FOOTER //
// ./src/assets/js/keyboard.js